



(function($){


var lastScrollTop = 0;
var fixhamburger=30;
var scrollingup=false;
var scrollStart = $(this).scrollTop();



 function hamburgerFloat(){
 	  var $hamburgerfloat = $('body').find('.wp-block-group.hamburger');
 	  $hamburgerfloat.addClass('hamburger-float');
 	  $hamburgerfloat.removeClass('hamburger-land');
 }

function hamburgerLand(){
	var $hamburgerland = $('body').find('.wp-block-group.hamburger');
    $hamburgerland.addClass('hamburger-land');
      $hamburgerland.removeClass('hamburger-float');
}
function hamburgerAppear(){
var $showhamburger = $('body').find('.wp-block-group.hamburger');
    $showhamburger.addClass('fadein');
    $showhamburger.removeClass('fadeout');
}
function hamburgerDisppear(){
    // console.log('hamburger disappear' );
	var $hidehamburger = $('body').find('.wp-block-group.hamburger');
    $hidehamburger.removeClass('fadein');
    $hidehamburger.addClass('fadeout');
}

 // if (scrollStart > fixhamburger){
 // hamburgerFloat();
 // }
 
 hasScrolled();

// $('.fancybox-iframe a').click(function() {
//      console.log("lightbox open ");
// });



  // if ($(".fancybox-bg")[0]){
  //   console.log("lock scroll ");
  //     $("body").css("overflow", "hidden!important");
  // } 
  // else {
  //    $("body").css("overflow", "auto");
  //     console.log("unlock scroll ");
  // }

$(window).on('scroll', function() {
hasScrolled();

 


});





function hasScrolled() {
    var st = $(this).scrollTop();
    var windowsize = $(window).width();
console.log("st = " + st);
if (windowsize < 979)  {
     hamburgerFloat();
   }
else {
     if (lastScrollTop > fixhamburger){   
   hamburgerFloat();
   }
  }
 if(st<=lastScrollTop){
    scrollingup=true;
          // console.log('scrolling up' )
          hamburgerAppear();

     if  (lastScrollTop > fixhamburger){
      hamburgerFloat();
        }
        else {
            hamburgerLand();
        }
     //scrolling up
      
        //fade in nav
      
        // $('header').removeClass('nav-up').addClass('nav-down');
  }

  else if(st>lastScrollTop){
        //scrolling down
      scrollingup=false;
      if ($(".hamburger").hasClass("hamburger-open")) {
        // console.log("hamburger has closs hamburger open");
        
      }
     if ($(".hamburger").hasClass("hamburger-closed")) {
          // console.log("hamburger has closs hamburger closed");
         // hamburgerDisppear();
          
      }

    
      
     

  }
  lastScrollTop = st;  


}
$( ".hamburger button.wp-block-navigation__responsive-container-open.always-shown" ).on( "click", function() {
    $('.hamburger').addClass('hamburger-open').removeClass('hamburger-closed');
  // console.log("hamburger button clicked");
} );

$( ".hamburger .wp-block-navigation__responsive-container-close" ).on( "click", function() {
    $('.hamburger').addClass('hamburger-closed').removeClass('hamburger-open');
  // console.log("close hamburger button clicked");
} );



var stopVideos = function () {
    var videos = document.querySelectorAll('iframe, video');
    Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === 'video') {
            video.pause();
        } else {
            var src = video.src;
            video.src = src;
        }
    });
};

$('.otter-popup__modal_header button.components-button.has-icon').click(function() {
    // console.log("click video");
            stopVideos();
});






})(jQuery);
//# sourceMappingURL=scripts.js.map

//# sourceMappingURL=scripts.js.map
